import React from "react";
import { ReactComponent as EmailIcon } from "../../../../assets/previewPage/socialIcons/email.svg";
import { ReactComponent as CallIcon } from "../../../../assets/previewPage/socialIcons/call.svg";
import { ReactComponent as FaceBookIcon } from "../../../../assets/previewPage/socialIcons/FaceBook.svg";
import { ReactComponent as InstaIcon } from "../../../../assets/previewPage/socialIcons/Insta.svg";
import { ReactComponent as Twitter } from "../../../../assets/previewPage/socialIcons/twitterIcon.svg";
import { ReactComponent as Messenger } from "../../../../assets/previewPage/socialIcons/messanger.svg";
import { ReactComponent as SnapIcon } from "../../../../assets/previewPage/socialIcons/snap.svg";
import { ReactComponent as YoutubeIcon } from "../../../../assets/previewPage/socialIcons/youtube.svg";
import { ReactComponent as TikTok } from "../../../../assets/previewPage/socialIcons/tiktok.svg";
import { ReactComponent as LinkedIn } from "../../../../assets/previewPage/socialIcons/LinkedIn.svg";
import { ReactComponent as Spotify } from "../../../../assets/previewPage/socialIcons/spotify.svg";
import { ReactComponent as Pinterest } from "../../../../assets/previewPage/socialIcons/pinterrest.svg";
import { ReactComponent as SoundCloud } from "../../../../assets/previewPage/socialIcons/soundCloud.svg";
import { ReactComponent as Twitch } from "../../../../assets/previewPage/socialIcons/twitch.svg";

const SocialCard = ({ item, styles }) => {
  const coloum_value = JSON.parse(item?.coloum_value);
  return (
    <div className="flex justify-center w-[90%] ">
      <div className="flex justify-center flex-wrap gap-[15px] place-content-center">
        {coloum_value?.email ? (
          <div>
            <a
              href={`mailto:${coloum_value?.email}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <EmailIcon className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.phone ? (
          <div>
            <a
              href={`tel:${coloum_value?.phone}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <CallIcon className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.facebook ? (
          <div>
            <a
            href={`https://facebook.com/${coloum_value?.facebook}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaceBookIcon className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.instagram ? (
          <div>
            <a
            href={`https://instagram.com/${coloum_value?.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstaIcon className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.twitter ? (
          <div>
            <a
            href={`https://twitter.com/${coloum_value?.twitter}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Twitter className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.fbmassenger ? (
          <div>
            <a
            href={`https://m.me/${coloum_value?.fbmassenger}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Messenger className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.snapchat ? (
          <div>
            <a
            href={`https://snapchat.com/add/${coloum_value?.snapchat}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SnapIcon className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.youtube ? (
          <div>
            <a
            // href={`https://www.youtube.com/${coloum_value?.youtube}`}
            href={coloum_value?.youtube.includes('youtube.com') ? coloum_value?.youtube : `https://www.youtube.com/@${coloum_value?.youtube}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <YoutubeIcon className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.tikTok ? (
          <div>
            <a
            href={coloum_value?.tikTok.includes('tiktok.com') ? coloum_value?.tikTok : `https://www.tiktok.com/@${coloum_value?.tikTok}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TikTok className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.linkedin ? (
          <div>
            <a
            href={coloum_value?.linkedin.includes('linkedin.com/in/') ? coloum_value?.linkedin : `https://www.linkedin.com/in/${coloum_value?.linkedin}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedIn className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.spotify ? (
          <div>
            <a
            href={`https://open.spotify.com/user/${coloum_value?.spotify}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Spotify className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.pinterest ? (
          <div>
            <a
            href={`https://pinterest.com/${coloum_value?.pinterest}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Pinterest className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.soundcloud ? (
          <div>
            <a
            href={`https://soundcloud.com/${coloum_value?.soundcloud}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SoundCloud className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
        {coloum_value?.twitch ? (
          <div>
            <a
            href={`https://www.twitch.tv/${coloum_value?.twitch}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Twitch className="w-[20px] h-[20px]" />
            </a>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SocialCard;
